module.exports = __webpack_public_path__ + "img/bank-uncheck-reviewed.3fc983df.svg";